<template>
  <div class="promo-bar" @click="$emit('open-form')">
    <div class="promo-link">
      <span class="promo-badge">파격</span>
      <span class="promo-text">
        <strong class="highlight">계약금 1,900만원대 </strong>
        <strong class="amount">파격 조건 변경</strong>
      </span>
      <span class="promo-arrow">→</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePromoBar',
  emits: ['open-form']
}
</script>

<style scoped>
.promo-bar {
  position: fixed;
  top: 60px; /* 모바일 헤더 높이 */
  left: 0;
  width: 100%;
  z-index: 999;
  background: linear-gradient(90deg, #1a3a5c 0%, #2d5a87 100%);
  cursor: pointer;
  overflow: hidden;
}

.promo-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.promo-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 20px;
  color: #fff;
  text-decoration: none;
}

.promo-badge {
  background: #ff3b3b;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  padding: 5px 10px;
  border-radius: 4px;
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.promo-text {
  font-size: 16px;
  font-weight: 600;
}

.promo-text .highlight {
  color: #ffd700;
  font-weight: 700;
}

.promo-text .amount {
  color: #ff6b6b;
  font-weight: 800;
  font-size: 18px;
  animation: blink 0.8s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.promo-arrow {
  font-size: 18px;
  font-weight: 700;
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(5px); }
}
</style>